export default __webpack_public_path__ + "static/benefitSectionBg-f3fff78b5ccfaeccf1ecb7625d830f37.png";